import { Input, Form, Alert } from "antd";
import ContentPadding from "../ContentConfig/ContentPadding";
import { ColorPickerFormItem } from "../Image/ImageConf";
import TrimmedInput from "../FormCommonField/FormTrimmedInput";

export default ({ node }) => {
  const defalutLabel = node?.data?.label || ""
  return (
    <>
      <Form.Item
        label={"common.label"}
        name="label"
        rules={[{ required: true }]}
      >
        <TrimmedInput/>
      </Form.Item>
      <Form.Item
        initialValue={"https://www.radicasys.com"}
        label={"common.link"}
        name="url"
        rules={[
          { required: true },
          { type: "url", message: "form.url.invalid" },
          { max: 2000, message: "form.input.max_length" },
        ]}
      >
        <Input />
      </Form.Item>
      <ColorPickerFormItem
        label={"common.text_color"}
        name="textColor"
        color={node.data.textColor || { r: 255, g: 255, b: 255, a: 1 }}
      />
      <ColorPickerFormItem
        label={"common.bg_color"}
        name="bgColor"
        color={node.data.bgColor || { r: 74, g: 144, b: 226, a: 1 }}
      />
      <Alert
        style={{ marginBottom: 15 }}
        message={"cnt.wechat.link_limit"}
        type="info"
      />
      <ContentPadding />
    </>
  );
};
